module Shared.Environments {
    export function environmentsMenuDirective(): ng.IDirective {
        return {
            restrict: "EA",
            templateUrl: "environmentsMenuTemplate",
            controller: EnvironmentsMenuController,
            controllerAs: "environmentsMenuCtrl",
            scope: true,
            bindToController: {
                currentEnvironmentName: "=",
                allEnvironmentNames: "="
            }
        }
    }

    module.directive("frendsEnvironmentsMenu", environmentsMenuDirective);

    export class EnvironmentsMenuController {
        public currentEnvironmentName: string;
        public allEnvironmentNames: IAllEnvironmentNames[];

        getEnvironmentDisplayNameName() {
            if (this.allEnvironmentNames) {
                return this.allEnvironmentNames.find(x => x.name === this.currentEnvironmentName).displayName;
            }
        }
    }

    export interface IAllEnvironmentNames {
        name: string;
        displayName: string;
    }

    module.controller("EnvironmentsMenuController", EnvironmentsMenuController);
}